(() => {
  if (window.brioRecipesReady) return;
  window.brioRecipesReady = true;
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-brio-recipes-open]');
    if (opener) {
      const dialog = document.getElementById(opener.getAttribute('aria-controls'));
      if (dialog && !dialog.open) { dialog.showModal(); dialog.scrollTop = 0; }
      return;
    }
    const closer = event.target.closest('[data-brio-recipes-close]');
    if (closer) closer.closest('dialog')?.close();
    if (event.target.matches?.('.brio-recipes-dialog')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.brio-recipes-dialog[open]').forEach(dialog => dialog.close()));
})();
